import { useEffect, useState } from "react";

// The data router of a component (the app's: MainScreen), created when it
// mounts and disposed when it unmounts. createRouter(): a new router (e.g.
// createBrowserRouter of the app's routes); a stable function (module
// level). Returns the router, or null before the first effect (render
// nothing meanwhile).
// In an effect, not in render (useState, a ref): under StrictMode React
// runs a mount effect, its cleanup and the effect again. A router created
// in render and disposed by the cleanup would be the one rendered, dead
// (no history listener, no subscriber: Back, Forward and navigations would
// not render). Here the second run creates the router that stays, the
// first one goes with its cleanup; outside StrictMode one router, disposed
// on the real unmount (the logout).
export function useDataRouter(createRouter) {
  const [router, setRouter] = useState(null);

  useEffect(() => {
    const created = createRouter();
    setRouter(created);
    return () => created.dispose();
  }, [createRouter]);

  return router;
}
